import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { useQuery } from "@/libs"

export const getRepicConfiguration = async (
  whiteLabelUuid: string
) => {
  const { data } =
    await api.get<RepicConfigurationResponse>(
      ENDPOINTS.REPIC_CONFIGURATION,
      {
        headers: {
          "x-white-label-uuid": whiteLabelUuid,
        },
      }
    )
  return data
}

export const useRepicConfiguration = (enabled = true) => {
  const { selectedWhiteLabel } = useAuth()
  const whitelabelUuid = selectedWhiteLabel?.uuid

  return useQuery({
    queryKey: [
      ENDPOINTS.REPIC_CONFIGURATION,
      whitelabelUuid,
    ],
    queryFn: async () =>
      getRepicConfiguration(whitelabelUuid as string),
    enabled: enabled && Boolean(whitelabelUuid),
    refetchOnMount: "always",
  })
}

export default useRepicConfiguration
